import React, { useState, useEffect } from 'react';
import Header from '../Utility/Components/Header';
import Footer from '../Utility/Components/Footer';

const AuthLayout = (props) => {
  const [showFooter, setShowFooter] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowFooter(true), 1200); // change time here
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="pageContainer">
      <Header history={props.history} />
      <div className="bodyContainer">{props.children}</div>
      {showFooter && <Footer />}
    </div>
  );
};

export default (AuthLayout);
